import { Button, Table } from "antd";
import { useEffect } from "react";
import { useState } from "react";
import { NotFound } from "../../../../sources/svg/svg";
import { convertToJalaliWithTime } from "../../../../tools/tools";
import { CaretDownOutlined, CaretRightOutlined } from "@ant-design/icons";

const DAValidList = ({ list = [], onSelect }) => {
  const [changeList, setChangeList] = useState([]);
  useEffect(() => {
    if (list?.length > 0) {
      setChangeList(list);
    }
  }, [list]);
  return (
    <>
      <div className="holder-table">
        <Table
          className="tbl-normal"
          columns={[
            {
              title: "نام",
              dataIndex: "firstName",
              key: "firstName",
              width: 150,
            },
            {
              title: "نام خانوادگی",
              dataIndex: "lastName",
              key: "lastName",
              width: 150,
            },
            {
              title: "کدملی",
              dataIndex: "certno",
              key: "certno",
              width: 150,
            },
            {
              title: "نام طرح",
              dataIndex: "planName",
              key: "planName",
              width: 150,
            },
            {
              title: "شماره آپتلی",
              dataIndex: "aptelMSIDSN",
              key: "aptelMSIDSN",
              width: 150,
            },
            {
              title: "تاریخ خرید",
              dataIndex: "purchaseDate",
              key: "purchaseDate",
              width: 150,
            },
            {
              title: "",
              dataIndex: "action",
              key: "action",
              width: 150,
              fixed: true,
            },
          ]}
          locale={{
            emptyText: (
              <>
                <NotFound text={"رکوردی یافت نشد."} />
              </>
            ),
          }}
          pagination={{ position: ["none"] }}
          dataSource={changeList.map((item, key) => ({
            key: key,
            firstName: item.firstName,
            lastName: item.lastName,
            certno: item.certno,
            planName: item.planName,
            aptelMSIDSN: item.aptelMSIDSN,
            purchaseDate: convertToJalaliWithTime(item.purchaseDate),
            action: (
              <>
                <Button className="btn-normal btn-aptel" onClick={() => onSelect(item)}>
                  تایید و ادامه
                </Button>
              </>
            ),
          }))}
          scroll={{ y: "100%" }}
        />
      </div>
    </>
  );
};

export default DAValidList;
